module.exports = __webpack_public_path__ + "media/images/black_history_month/arrow-right-e40d2c5f537698ccd71f7c5b2b7e3ec4.svg";